// extracted by mini-css-extract-plugin
export default {"qa":"styles_qa__C2mnu","plus":"styles_plus__a0KIj","pressed":"styles_pressed__p9VIa"};